export function getErrorList(state) {
    return state.errorList
}


// WEBPACK FOOTER //
// ./src/app/redux/selectors/selectorCallAPI.js